import axios from '../axios'
import useJwt from '../auth/useJwt'

const axiosIns = useJwt(axios, {})

export default axiosIns
